import { ChartBarIcon as PhosphorChartBarIcon } from "@phosphor-icons/react/dist/ssr/ChartBar";

import { createAppIcon } from "@/components/createAppIcon";

export const BarChartIcon = /* @__PURE__ */ createAppIcon(PhosphorChartBarIcon);
